import apiClient from './client';

export interface User {
  id: string;
  email: string;
  username?: string;
  role: 'admin' | 'user';
  created_at?: string;
  telegram_id?: number | null;
}

export interface CreateUserRequest {
  email: string;
  password?: string;
  username?: string;
  role?: 'admin' | 'user';
}

export interface UpdateUserRequest {
  email?: string;
  password?: string;
  username?: string;
  role?: 'admin' | 'user';
}

export const usersApi = {
  async getAll(): Promise<User[]> {
    const response = await apiClient.get<{ users: User[] }>('/admin/users');
    return response.data.users;
  },

  async getById(id: string): Promise<User> {
    const response = await apiClient.get<{ user: User }>(`/admin/users/${id}`);
    return response.data.user;
  },

  async create(data: CreateUserRequest): Promise<User> {
    const response = await apiClient.post<{ user: User; message: string }>('/admin/users', data);
    return response.data.user;
  },

  async update(id: string, data: UpdateUserRequest): Promise<User> {
    const response = await apiClient.put<{ user: User; message: string }>(`/admin/users/${id}`, data);
    return response.data.user;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete<{ message: string }>(`/admin/users/${id}`);
  },
};



